<template>
  <div @mouseover="mouseOver" @mouseleave="mouseLeave">
    <div >Enrollment over Time</div>
    <div>
      <div v-if="active">
        <apexchart width="380" type="line" :options="options" :series="series"></apexchart>
      </div>
      <div v-else class="content">
        <img src="../assets/pqccampus.png">
        <div class="text"><h1>Enrollment Over Time</h1></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
   return {
    active: false,
    options: {
      xaxis: {
        title: {
          text: 'Year'
        },
        categories: [1990, 1996, 2000, 2004, 2008, 2012, 2016, 2020]
      },
      yaxis: {
        title: {
          text: 'Number of Students'
        }
      }
    },
    series: [{
        name: 'Enrollment',
        data: [300, 400, 450, 500, 490, 600, 700, 910]
      }]
    }
  },
  methods: {
    mouseOver: function() {
      this.active = true;
    }, 
    mouseLeave: function() {
      this.active = false;
    }
  },
};
</script>

<style scoped>
.text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
}

.content {
  text-align: center;
  position: relative;
}

.img {
  object-fit:cover;
}
</style>